/*
 * @Date: 2019-12-08 17:13:38
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 16:52:10
 * @FilePath: /rongxin.web/src/views/home/index.js
 */
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import Service from './servece.js';
// component
import Navbar from '../../../components/navbar/index.vue';
import ProductService from '../../home/product-service/index.vue';
import contactUs from '../../home/contact-us/index.vue';
export default {
  name: 'home',
  components: {
    swiper,
    swiperSlide,
    Navbar,
    ProductService,
    contactUs
  },
  data() {
    return {
      fixed: false,
      fromisActiveClass: 'aboutUs',
      color: '#fff',
      params: {
        clientId: '6188e0dbc2d92675c94f5598',
        catalogId: '61af319c1672119f533e28ad',
        source: 'guanWang',
        limit: 100,
        status: 1 // 已发布数据
      },
      imgArr: [
        // 解决loop:false时 无法轮播完所有图片
        {
          monthDay: '',
          title: '',
          content: ''
        },
        {
          monthDay: '',
          title: '',
          content: ''
        },
        {
          monthDay: '',
          title: '',
          content: ''
        }
      ],
      tableList: [],
      swiperOption: {
        // autoplay: true,
        // loop: true,
        freeMode: true,
        slidesPerGroup: 1,
        speed: 500,
        slidesPerView: 4,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.getDevelopmentList();
  },
  mounted() {
    this.$nextTick(() => {
      new Swiper('.swiper-container', {
        clickable: true,
        speed: 3000
        // autoplay: 5000
      });
    });
    window.addEventListener('scroll', this.handleScroll, true);
  },
  destroyed() {
    window.addEventListener('scroll', this.handleScroll, true);
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    handleScroll(){
      if(document.body.scrollHeight > window.innerHeight) {
        this.fixed = true;
      }
    },
    goHome() {
      this.$router.push({path: 'home'});
    },
    getDevelopmentList() {
      Service.getDevelopmentList(this.params).then(data => {
        // this.tableList = data.data.list;
        this.tableList = [...data.data.list, ...this.imgArr];
        this.tableList.forEach(item => {
          item.description = item.description;
        });
      });
    }
  }
};
